import httpservice from "./httpservice";

class IntegrationService {
  get(params = {}) {
    return httpservice.get("/admin/cp/integrations", { params });
  }
  getUnassignedFirsInvoices(params = {}) {
    return httpservice.get("/admin/cp/integrations/inbox/unassigned-firs-invoices", { params });
  }
  assignFirsInvoice(params = { id: "", integrationId: "" }) {
    return httpservice.put("/admin/cp/integrations/inbox/assign-firs-invoice", {}, { params });
  }
  retryFirsInvoice(id) {
    return httpservice.put("/admin/cp/integrations/inbox/retry-firs-invoice", {}, { params: { id } });
  }
  onboard(data, params = { organizationId: "", integrationId: "" }) {
    return httpservice.post("/admin/cp/integrations/onboard/call", data, { params });
  }

  getInterfaces(params = {}) {
    return httpservice.get("/admin/cp/integrations/interfaces", { params });
  }

  getIntegrationsInterface(params = {}) {
    return httpservice.get(`/admin/cp/integrations/interface/`, { params });
  }
  addIntegration(data = { interfaceId: "" }, organizationId) {
    return httpservice.post(`/admin/cp/integrations`, data, { params: { organizationId } });
  }
  updateIntegration(data = {}, params = {}) {
    return httpservice.put(`/admin/cp/integrations`, data, { params });
  }
  activate(data = {}, params = {}) {
    if (data?.status === "ACTIVE") {
      return httpservice.put(`/admin/cp/integrations/deactivate`, data, { params });
    }
    return httpservice.put(`/admin/cp/integrations/activate`, data, { params });
  }

  // 52d55678-74cc-4768-a32b-2a37c0396309
  getEntityDetails(data, params = {}) {
    return httpservice.post(`/admin/cp/integrations/onboard/call`, data, { params });
  }

  proceed(data, params = {}) {
    return httpservice.post(`/admin/cp/integrations/onboard/proceed/`, data, { params });
  }
}

export default new IntegrationService();
